export default __webpack_public_path__ + "static/media/screenshot1.38226c90.jpg";